var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('a',{attrs:{"href":'/'+this.hotelId,"target":"_black"}},[_vm._v("クチコミを見る")])])
}
var staticRenderFns = []

export { render, staticRenderFns }